export const defaultIconSize = <const>{
    40: 24,
    24: 20,
};
